<script lang="ts">
	import HeaderItemButton from './HeaderItemButton.svelte';
	export let name: string;
	export let url: string;
	export let params: string;
	export let newTab: boolean = false;
	export let beta: boolean = false;
	export let live: boolean = false;
	export let ended: boolean = false;

	$: url_params = params ? `?${params}` : '';
</script>

{#if !newTab}
	<a href="{url}{url_params}">
		<HeaderItemButton {name} {url} {beta} {live} {ended} />
	</a>
{:else}
	<a href="{url}{url_params}" target="_blank" rel="noreferrer">
		<HeaderItemButton {name} {url} {beta} {live} {ended} />
	</a>
{/if}
